module.exports = __webpack_public_path__ + "assets/je-orange-sm-logo-191175.svg";